export enum Paging {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
}
